import 'css/src/components/common/ui/Badge.module.scss';

import React from 'react';
import classNames from 'classnames';

/**
 * A standalone badge used for showing small numerical values or status descriptions.
 *
 * The badge is positioned INLINE (span)
 *
 * For consistent font sizing, nest this component in a typography element
 * e.g. <h4><Badge>My Text</Badge></h4>
 */

export enum ThemeOptions {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    SUCCESS = 'success',
    DANGER = 'danger',
    WARNING = 'warning',
    INFO = 'info',
    LIGHT = 'light',
    DARK = 'dark',
}

type BadgeProps = {
    theme?: ThemeOptions;
    rounded?: boolean;
    className?: string;
    children?: React.ReactNode;
};

const Badge = React.memo(function Badge({
    theme = ThemeOptions.PRIMARY,
    rounded = false,
    className = '',
    children,
}: BadgeProps) {
    const finalClass = classNames('l5-badge', theme, className, {
        'badge-rounded': rounded,
    });
    return <span className={finalClass}>{children}</span>;
});

export default Badge;
